enum EVerticalProgressBarTooltipVisibilityStatus {
    Visible = "visible",
    Hidden = "hidden"
}

enum EVerticalProgressBarTooltipPlacement {
    Center = "center",
    Left = "left"
}

enum EVerticalProgressBarColorStatus {
    NotStarted = "notStarted",
    InTime = "inTime",
    Expired = "expired"
}

enum EVerticalProgressBarFillLevel {
    NotFilled = "notFilled",
    OnePieceFilled = "onePieceFilled",
    TwoPiecesFilled = "twoPieceFilled",
    ThreePiecesFilled = "threePieceFilled"
}

enum EVerticalProgressBarVariant {
    FullBar = "fullBar",
    CroppedBar = "croppedBar",
    Standalone = "standalone"
}

enum EVerticalProgressBarInteractivityStatus {
    Idle = "idle",
    Active = "active"
}

enum EVerticalProgressBarAccessibilityStatus {
    Accessible = "accessible",
    NotAccessible = "notAccessible"
}

enum EVerticalProgressBarStarVisibilityStatus {
    Visible = "visible",
    Hidden = "hidden"
}

type TVerticalProgressBarPieceRenderConfig = {
    variant?: EVerticalProgressBarVariant
    status: EVerticalProgressBarColorStatus
    withoutStar?: boolean
    isMobile?: boolean
    isBottomRounded?: boolean
    isHidden?: boolean
    isFilled?: boolean
    isAccessible?: boolean
    isBarFullHeight?: boolean
    isActionAffected?: boolean
    color?: string
}

export type { TVerticalProgressBarPieceRenderConfig }

export {
    EVerticalProgressBarVariant,
    EVerticalProgressBarTooltipVisibilityStatus,
    EVerticalProgressBarTooltipPlacement,
    EVerticalProgressBarFillLevel,
    EVerticalProgressBarColorStatus,
    EVerticalProgressBarInteractivityStatus,
    EVerticalProgressBarAccessibilityStatus,
    EVerticalProgressBarStarVisibilityStatus
}
